"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumableMetricsResponse = exports.ConsumableMetric = exports.ConsumablePerformance = exports.CustomerResponse = exports.Customer = exports.FleetDeviceList = exports.FleetFilterList = exports.FleetFilter = exports.ConsumablesFillLevelFilters = exports.ConsumablesFillLevel = exports.StatusFilters = exports.ModelsFilters = exports.BrandsFilters = exports.FilterKey = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../device"));
const User = __importStar(require("../../../../../user"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Fleet.Schema';
/*
 * `controllers/v2/fleet/index.js`
 */
exports.FilterKey = effect_1.Schema.Literal('brands', 'models', 'status', 'levels').annotations({
    identifier: `${exports.NAMESPACE}.FilterKey`,
    title: 'Fleet filter key',
});
exports.BrandsFilters = effect_1.Schema.Struct({
    _tag: effect_1.Schema.Literal('brands'),
    brands: effect_1.Schema.Array(effect_1.Schema.Struct({
        id: Device.Vendor.Code,
        name: effect_1.Schema.String,
    })),
}).annotations({
    identifier: `${exports.NAMESPACE}.BrandsFilters`,
    title: 'BrandsFilters',
    description: 'Brands (device vendors) the caller may filter the fleet by',
});
exports.ModelsFilters = effect_1.Schema.Struct({
    _tag: effect_1.Schema.Literal('models'),
    models: effect_1.Schema.Array(effect_1.Schema.Struct({
        id: Device.Class.Common.ModelCode,
        name: effect_1.Schema.String,
    })),
}).annotations({
    identifier: `${exports.NAMESPACE}.ModelsFilters`,
    title: 'ModelsFilters',
    description: 'Device models the caller may filter the fleet by',
});
exports.StatusFilters = effect_1.Schema.Struct({
    _tag: effect_1.Schema.Literal('status'),
    status: effect_1.Schema.Array(effect_1.Schema.Literal('connected', 'disconnected')),
}).annotations({
    identifier: `${exports.NAMESPACE}.StatusFilters`,
    title: 'StatusFilter',
    description: 'Connection statuses the caller may filter the fleet by',
});
exports.ConsumablesFillLevel = effect_1.Schema.Literal('lessThan20', '20To40', '40To60', '60To80', 'moreThan80').annotations({
    identifier: `${exports.NAMESPACE}.ConsumablesFillLevel`,
    title: 'Consumables fill level',
});
exports.ConsumablesFillLevelFilters = effect_1.Schema.Struct({
    _tag: effect_1.Schema.Literal('levels'),
    levels: effect_1.Schema.Array(exports.ConsumablesFillLevel),
}).annotations({
    identifier: `${exports.NAMESPACE}.ConsumablesFillLevelFilters`,
    title: 'ConsumablesFillLevelFilter',
    description: 'Consumable fill-level buckets the caller may filter the fleet by',
});
exports.FleetFilter = effect_1.Schema.Union(exports.BrandsFilters, exports.ModelsFilters, exports.StatusFilters, exports.ConsumablesFillLevelFilters).annotations({
    identifier: `${exports.NAMESPACE}.FleetFilter`,
    title: 'FiltersResponse',
    description: 'One filter facet; `_tag` names the facet and the sibling key holds its values',
});
exports.FleetFilterList = effect_1.Schema.Array(exports.FleetFilter).annotations({
    identifier: `${exports.NAMESPACE}.FleetFilterList`,
    description: 'The requested filter facets, in `keys` order',
});
/** `S.Array(Culligan.Device.Class.Device)`: full device documents, not the dashboard list item. */
exports.FleetDeviceList = effect_1.Schema.Array(Device.Class.Device).annotations({
    identifier: `${exports.NAMESPACE}.FleetDeviceList`,
    description: 'Every device matching the filters, as stored (no pagination)',
});
exports.Customer = effect_1.Schema.Struct({
    id: User.Id,
    firstName: effect_1.Schema.String,
    lastName: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.Customer`,
    title: 'Customer',
    description: 'Customer information',
});
exports.CustomerResponse = effect_1.Schema.Struct({
    customer: exports.Customer,
}).annotations({
    identifier: `${exports.NAMESPACE}.CustomerResponse`,
    title: 'CustomerResponse',
    description: 'Response containing customer information',
});
/*
 * `FleetRepository.getConsumablesMetrics()`: a static sample until the
 * aggregation is implemented. The shape is the contract; the numbers are not.
 */
exports.ConsumablePerformance = effect_1.Schema.Struct({
    id: effect_1.Schema.String,
    label: effect_1.Schema.String,
    value: effect_1.Schema.Number,
}).annotations({
    identifier: `${exports.NAMESPACE}.ConsumablePerformance`,
    description: 'Relative performance of one consumable variant (for example a flavour)',
});
exports.ConsumableMetric = effect_1.Schema.Struct({
    id: effect_1.Schema.String,
    label: effect_1.Schema.String,
    ranges: effect_1.Schema.Array(effect_1.Schema.String),
    values: effect_1.Schema.Array(effect_1.Schema.Number),
    performance: effect_1.Schema.optionalWith(effect_1.Schema.Array(exports.ConsumablePerformance), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ConsumableMetric`,
    title: 'ConsumableMetric',
    description: 'Fill-level distribution of one consumable family: `ranges` labels the buckets, `values` counts devices per bucket',
});
exports.ConsumableMetricsResponse = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.ConsumableMetric),
}).annotations({
    identifier: `${exports.NAMESPACE}.ConsumableMetricsResponse`,
});
//# sourceMappingURL=schema.js.map